import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import SidebarNav from './SidebarNav';
import SvgIcon from '@material-ui/core/SvgIcon';
import { ReactComponent as PortalLogo } from 'images/srm_portal_logo_small.svg';
import Proptypes from 'prop-types';

const Sidebar = props => {
  const { isDesktop, isSidebarCollapsedDesktop, menuMain = [] } = props;

  const classes = useStyles(props);

  return (
    <aside className={classes.sidebar}>
      <div className={classes.sidebarHeader}>
        <Link to="/">
          <SvgIcon className={classes.logo}>
            <PortalLogo />
          </SvgIcon>
          <Typography
            component="h2"
            variant="h5"
            color="inherit"
            noWrap
            className={classes.title}
          >
            {/* <span className={classes.name}>SRM-Portal</span> */}
          </Typography>
        </Link>
      </div>
      <SidebarNav
        isCollapsed={isDesktop && isSidebarCollapsedDesktop}
        menuMain={menuMain}
      />
    </aside>
  );
};

const useStyles = makeStyles(theme => ({
  sidebar: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    color: theme.palette.text.primary,
    background: theme.palette.background.default,
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  sidebarHeader: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    padding: '0 8px',
    background: theme.palette.background.default,
    ...theme.mixins.toolbar,
    // boxShadow:' 0px 2px 2px 0px rgba(97,96,97,1)'
  },
  sidebarTitleLink: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'flex',
    // '&:hover': {
    //   '& $logo': {
    //     color: '#fff',
    //   },
    // },
  },
  logo: props => ({
    fill: theme.palette.primary.main,
    height: '3rem',
    width: '3rem',
    cursor: 'pointer',
    // fontSize: '20px',
    // height: props.isSidebarCollapsedDesktop ? '30px' : '50px',
    fontSize: props.isSidebarCollapsedDesktop ? '10px' : '20px',
  }),
  title: props => ({
    // fontSize: '20px',
    // fontWeight: 400,
    position: 'relative',
    overflow: 'visible',
    marginLeft: '5px',
    display:
      props.isDesktop && props.isSidebarCollapsedDesktop ? 'none' : 'block',
  }),
  name: {},
  tagline: {
    fontSize: 8,
    fontWeight: 'bold',
    position: 'absolute',
    top: '100%',
    marginTop: -5,
    background: theme.palette.primary.main,
    color: '#fff',
    borderRadius: 2,
    padding: '1px 3px',
    right: 0,
  },
}));
Sidebar.propTypes = {
  isDesktop: Proptypes.bool,
  isSidebarCollapsedDesktop: Proptypes.bool,
  menuMain: Proptypes.array,
};
export default Sidebar;
